export const HOME = "/";
export const ABOUT = "/about";
export const RESUME = "/resume";
export const CONTACT = "/contact";
export const PORTFOLIO = "/portfolio";
export const PORTFOLIO_SINGLE = "/portfolio/:index";
export const BLOG = "/blog";
export const BLOG_SINGLE = "/blog/:index";
export const SERVICES = "/services";
export const SERVICES_SINGLE = "/services/:name";
